import logo from "../../images/title2.png"


export default function Title() {
  return (
    <img className="landing-title" src={logo} alt="landing logo" />
   
  );
}